module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "userinfo"
    }
  }, [_c('h1', [_vm._v("ユーザー情報")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('table', [_c('tr', [_c('th', [_vm._v("名前")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.fullname) + "（" + _vm._s(_vm.userType) + "）")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("カナ")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.kana))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("ユーザー名(ID)")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.user_name))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("mail")]), _c('td', [_vm._v(":")]), _c('td', [_vm._v(_vm._s(_vm.$store.state.userInfo.mail_address))])])])]), _vm._v(" "), _c('router-link', {
    staticClass: "button",
    attrs: {
      "tag": "button",
      "to": "/Spchangeuser",
      "title": "予約変更"
    }
  }, [_c('span', [_vm._v("情報を変更する")])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-fb7a68ee", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fb7a68ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mobile/UserInfo/SpUserInfo.vue
// module id = 753
// module chunks = 0